export default __webpack_public_path__ + "locales/nl/JavascriptSdk.json?hash=689d12a9a91932bb52758401fb095de9";